import { useDocumentTitle, siteTitle } from "@1-now/booking-core";
import { FC } from "react";
import SectionGridFilterCard from "./SectionGridFilterCard";
import BackRouteButton from "shared/BackRouteButton/BackRouteButton";
import { useData } from "data/data-provider";

export interface ListingCarPageProps {
  className?: string;
}

const AvailableCarsPage: FC<ListingCarPageProps> = ({ className = "" }) => {
  const { companyDetails } = useData();
  // "Available cars — <operator>", always, like Vehicles (1NOW-11189).
  useDocumentTitle(companyDetails ? siteTitle(companyDetails, "Available cars") : undefined);
  return (
    <div
      className={`nc-ListingCarPage relative ${className}`}
      data-nc-id="ListingCarPage"
    >
      <div className="container relative">
        <div className="mt-2">
          <BackRouteButton />
        </div>
        <SectionGridFilterCard className="pt-8 pb-20 sm:pt-10 lg:pb-24" />
      </div>
    </div>
  );
};

export default AvailableCarsPage;
